import { Grid, GridItem, VerticalSpacer } from "@innovationnorway/lighthouse-components";
import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { UserAccount } from "../../../main/models/user-account";
import { getUserAccounts } from "../../apis/getUserAccounts";
import ActorApplications from "../actorApplications/actorApplications";
import ActorTabs from "../actorTabs/actorTabs";
import AddAccountModal from "../addAccountModal/addAccountModal";
import LoaderSmall from "../loaderSmall/loaderSmall";

interface ActorContainerProps {
  setCurrentAccountByAccountPublicId: (accountPublicId: string) => void;
  currentAccount?: UserAccount;
}

const ActorContainer = ({ setCurrentAccountByAccountPublicId, currentAccount }: ActorContainerProps) => {
  const { isValidating } = useSWR(`userAccounts`, getUserAccounts);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);

  useEffect(() => {
    if (currentAccount && !currentAccount?.emailVerified) {
      setShowAddAccountModal(true);
    }
  }, [currentAccount]);

  return (
    <>
      <ActorTabs
        setCurrentAccountByAccountPublicId={setCurrentAccountByAccountPublicId}
        currentAccountPublicId={currentAccount?.account.publicId}
      />
      <VerticalSpacer size="xl" />
      {!isValidating ? (
        currentAccount?.emailVerified === true ? (
          <ActorApplications currentAccountPublicId={currentAccount?.account.publicId} />
        ) : (
          currentAccount != null && (
            <AddAccountModal
              accountName={currentAccount?.account.name}
              onClose={(publicId) => publicId && setCurrentAccountByAccountPublicId(publicId)}
              accountPublicId={currentAccount.account.publicId}
              showModal={showAddAccountModal}
              setShowModal={setShowAddAccountModal}
            />
          )
        )
      ) : (
        <Grid>
          <GridItem spanLarge={12} spanMedium={12} spanSmall={4} offsetLarge={6} offsetMedium={6} offsetSmall={2}>
            <LoaderSmall />
          </GridItem>
        </Grid>
      )}
    </>
  );
};

export default ActorContainer;
